export const RATE_LIMIT_RETRY_FALLBACK_MS = 1100;

export function isRateLimitErrorMessage(message: string | undefined | null): boolean {
  return typeof message === 'string' && /rate limit exceeded/i.test(message);
}

export function parseRetryAfterMsFromMessage(message: string | undefined | null): number | null {
  if (!message) return null;
  const match = message.match(/try again in (\d+)/i);
  if (!match) return null;
  return Math.max(1000, Number(match[1]) * 1000);
}

export function parseRetryAfterMsFromResponse(response: Response, message?: string): number {
  const header = response.headers.get('retry-after');
  if (header) {
    const seconds = Number(header);
    if (!Number.isNaN(seconds) && seconds >= 0) {
      return Math.max(1000, seconds * 1000);
    }
  }
  return parseRetryAfterMsFromMessage(message) ?? RATE_LIMIT_RETRY_FALLBACK_MS;
}
